const map = {
	"./AdvancedFreediverSc": [
		34485,
		[
			4485
		]
	],
	"./AdvancedOpenWaterSc": [
		29556,
		[
			9556
		]
	],
	"./BasicFreediverSc": [
		76601,
		[
			6601
		]
	],
	"./CoralReefConservationSc": [
		38839,
		[
			8839
		]
	],
	"./DiveMasterSc": [
		23533,
		[
			3533
		]
	],
	"./DriftDiverSc": [
		94784,
		[
			4784
		]
	],
	"./EFRSc": [
		70198,
		[
			198
		]
	],
	"./EnrichedAirDiverSc": [
		58733,
		[
			8733
		]
	],
	"./EquipmentSpecialistSc": [
		96976,
		[
			6976
		]
	],
	"./FreediverSc": [
		16971,
		[
			6971
		]
	],
	"./MasterFreediverSc": [
		58921,
		[
			8921
		]
	],
	"./MermaidSc": [
		85238,
		[
			5238
		]
	],
	"./OpenWaterSc": [
		24506,
		[
			4506
		]
	],
	"./PeakPerformanceBuoyancySc": [
		22572,
		[
			2572
		]
	],
	"./RescueDiverSc": [
		31022,
		[
			1022
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9679;
module.exports = webpackAsyncContext;